<template>
  <div class="col-12 text-center" v-if="fetchingBuddies">
    <div class="alert alert-primary" role="alert">
      Buddies ophalen.
    </div>
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Laden...</span>
      </div>
    </div>
  </div>
  <div class="col-12 buddy-select-bar" v-hover="onHoverOver" v-else>
    <div class="container">
      <div class="buttons-wrapper">
        <div class="col-lg-4" :key="buddy.id" v-for="buddy in buddies">
          <BuddySelectButton :interactable="interactable" :buddy="buddy" @clicked="buddyClicked"></BuddySelectButton>
        </div>
      </div>
    </div>
    <HoverInfo :show="hoveringOver" :content="'Klik hier de gewenste buddy'" :offset-y="12"></HoverInfo>
  </div>
</template>

<script>
import BuddySelectButton from "@/components/Common/BuddySelectButton";
import {BuddyApi} from "sandpiper_api";
import log from "@/utils/logger";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "BuddySelectBar",
  components: {HoverInfo, BuddySelectButton},
  props: {
    //title: String
    //initialBuddyId: Number,
    interactable: Boolean
  },
  inject: ["doApiRequest"],
  data() {
    return {
      fetchingBuddies: false,
      buddies: [],
      defaultBuddyId: null,
      selectedBuddy: null,
      hoveringOver: false,
    }
  },
  methods: {
    overrideBuddy(buddy) {
      log.info("Overriding selected buddy from parent - %o", buddy);
      if (this.fetchingBuddies || this.buddies.length === 0) {
        this.defaultBuddyId = buddy.id;
      } else {
        let internalBuddy = this.buddies.find(b => b.id === buddy.id);
        if (internalBuddy) {
          this.selectBuddy(internalBuddy);
        }
      }
    },
    fetchQueryParams() {
      this.defaultBuddyId = parseInt(this.$route.query.buddy) || null;
    },
    buddyClicked(buddy) {
      log.info("[BuddySelectBar] buddy clicked: %o", buddy);
      this.selectBuddy(buddy);
    },
    selectBuddy(buddy) {
      if (this.selectedBuddy) {
        if (buddy.id === this.selectedBuddy.id) {
          return;
        }

        this.selectedBuddy.selected = false;
      }

      this.selectedBuddy = buddy;
      this.selectedBuddy.selected = true;

      this.saveSelectedBuddy(this.selectedBuddy.id);
      this.$emit("buddyChanged", this.selectedBuddy);
    },
    saveSelectedBuddy(id) {
      sessionStorage.setItem("selected_buddy_id", id);
    },
    async fetchBuddies() {
      try {
        log.info("Fetching buddies");
        this.fetchingBuddies = true;

        this.buddies = [];
        this.buddies = await this.doApiRequest(() => new BuddyApi().getActiveBuddies());
      } catch (e) {
        // TODO - handle error
        log.error("Failed to fetch buddies - %o", e);
      } finally {
        this.fetchingBuddies = false;
        this.$emit("buddiesLoaded", this.buddies);

        if (this.buddies.length > 0) {
          let defaultBuddy;

          if (this.defaultBuddyId !== null) {
            defaultBuddy = this.buddies.find(b => b.id === this.defaultBuddyId);
          }

          if (defaultBuddy) {
            this.selectedBuddy = defaultBuddy;
          } else {
            this.selectedBuddy = this.buddies[0];
          }

          this.selectedBuddy.selected = true;
          this.$emit("buddyChanged", this.selectedBuddy);
        }
      }
    },
    onHoverOver(state) {
      this.hoveringOver = state;
    }
  },
  created() {

    //order of buddy ID importance: 1: override (from planActivity), 2: from route, 3: from sessionStorage
    this.fetchQueryParams();

    //if no buddy id in query
    if (this.defaultBuddyId == null) {
      let savedBuddy = sessionStorage.getItem("selected_buddy_id");
      if (savedBuddy) {
        this.defaultBuddyId = parseInt(savedBuddy);
      } else {
        //no buddy id saved in sessionStorage either
      }
    }

    //defaultBuddyId can still be overridden by parent


    this.fetchBuddies();
  }
}
</script>

<style lang="scss" scoped>
.buddy-select-bar {
  background-color: white;
  box-shadow: $default-shadow;

  .container {
    padding: 0px;
  }
}

.buttons-wrapper {
  padding: 25px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  overflow-x: auto;
}
</style>